import React from 'react';
import PropTypes from 'prop-types';

import styles from './Spacer.css';

const Spacer = ({ size, media }) => {
  const classId = ['spacer', media, size].filter(i => !!i).join('-');
  return <div className={styles[classId]} />;
};

Spacer.defaultProps = {
  size: 8,
  media: null,
};

Spacer.propTypes = {
  size: PropTypes.oneOf([1, 2, 4, 6, 8, 16, 32]),
  media: PropTypes.oneOf([null, 'tablet']),
};

export default Spacer;
